import DATA_INTRO_ILO1 from "./Introduction/101DataIntroILO1";
import DATA_BENEFITS_ILO1_1 from "./Introduction/102DataBenefitsILO1_1";
import DATA_BENEFITS_ILO1_2 from "./Introduction/103DataBenefitsILO1_2";
import DATA_BO_1 from "./BO/104DataBO";
import DATA_BO_2 from "./BO/105DataBO";
import DATA_BO_3 from "./BO/106DataBO";
import DATA_BO_4 from "./BO/107DataBO";
import DATA_BO_5 from "./BO/108DataBO";
import DATA_BO_6 from "./BO/109DataBO";
import DATA_BO_7 from "./BO/110DataBO";
import DATA_BO_8 from "./BO/111DataBO";
import DATA_BO_9 from "./BO/112DataBO";
import DATA_BO_10 from "./BO/113DataBO";
import DATA_BO_DEMO_ILO1_END from "./BO/114DataBOEnd";

const ILO_WORKFLOW = [
  { page: "ILO_101", type: "intro-template" as TemplateType, data: DATA_INTRO_ILO1 },
  {
    page: "ILO_102",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_ILO1_1,
  },
  {
    page: "ILO_103",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_ILO1_2,
  },
  {
    page: "ILO_104",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_1,
  },
  {
    page: "ILO_105",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_2,
  },
  {
    page: "ILO_106",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_3,
  },
  {
    page: "ILO_107",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_4,
  },
  {
    page: "ILO_108",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_5,
  },
  {
    page: "ILO_109",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_6,
  },
  {
    page: "ILO_110",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_7,
  },
  {
    page: "ILO_111",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_8,
  },
  {
    page: "ILO_112",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_9,
  },
  {
    page: "ILO_113",
    type: "video-journey-template" as TemplateType,
    data: DATA_BO_10,
  },
  {
    page: "ILO_114",
    type: "end-template" as TemplateType,
    data: DATA_BO_DEMO_ILO1_END,
  },
];

export default ILO_WORKFLOW;
